import ReviewCard from "@/components/campaignBuilder/review/ReviewCard/ReviewCard";
import CauseSelector from "@/components/charity/CauseSelector";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";

/**
 * The "Select your cause beneficiary" block — Step 4 Review (DIV-7811).
 *
 * A thin mount of the shared `CauseSelector` (components/charity), the same component the
 * Campaign Tester's SeedCampaignDialog wires — per the ticket, the selector is used directly
 * rather than rebuilt. It fetches the live cause catalogue (`GET /charity/causes`, backed by
 * the Credit Beneficiaries Shopify collection), owns the browse grid, the detail panel, the
 * even-share split and the roll-over switch; headerless `ReviewCard` supplies the Step 4 card
 * chrome around it.
 *
 * State lives in CampaignBuilderContext, which is what makes the ticket's two behaviours fall
 * out for free:
 *   - event-based save: every add/remove lands in `selectedCauses` the moment it happens;
 *   - restore: returning to Step 4 re-mounts the selector with the saved picks pre-checked,
 *     because `value` IS the saved state.
 *
 * The at-least-one-cause rule is enforced at the publish CTA (CheckoutCard), not here — an
 * empty pick is a legitimate state to browse from, it just can't be published.
 */
export default function CauseBeneficiaryCard() {
  const { selectedCauses, setSelectedCauses, rolloverEnabled, setRolloverEnabled } =
    useCampaignBuilder();

  return (
    <ReviewCard>
      <CauseSelector
        value={selectedCauses}
        onChange={setSelectedCauses}
        rollover={rolloverEnabled}
        onRolloverChange={setRolloverEnabled}
      />
    </ReviewCard>
  );
}
